import { Component, h, Prop, Element, Watch, Method } from "@stencil/core"
import { AnimationName } from "./types"
import { animation } from "../../core/helpers/webcomponent-helpers"

@Component({
  tag: "sdx-animation",
  shadow: true,
})
export class Animation {
  @Element() public el!: HTMLSdxAnimationElement

  /**
   * The animation to play.
   */
  @Prop() public animationName?: AnimationName

  /**
   * The length of the animation.
   */
  @Prop() public animationDuration?: number

  @Watch("animationName")
  public animationNameChanged() {
    this.runAnimation(this.animationName)
  }

  public componentWillLoad() {
    return this.runAnimation(this.animationName, 0)
  }

  @Method()
  public async runAnimation(
    animationName: AnimationName | undefined,
    duration = this.animationDuration
  ) {
    switch (animationName) {
      case "scale-in":
        return animation.scaleIn(this.el, duration)

      case "scale-out":
        return animation.scaleOut(this.el, duration)

      case "fade-in":
        return animation.fadeIn(this.el, duration)

      case "fade-out":
        return animation.fadeOut(this.el, duration)

      default:
        return
    }
  }

  public render() {
    return <slot />
  }
}
